/* eslint-disable react-hooks/exhaustive-deps */
/* โครงหน้าของ portal ลูกค้า (แถบบน + เนื้อหากว้างไม่เกิน 980px) */
import React, { createContext, useContext, useEffect, useState } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { Avatar, Dropdown, Flex, Form, Input, Modal, Spin, Typography, message } from "antd";
import { KeyOutlined, LogoutOutlined, UserOutlined } from "@ant-design/icons";
import logo from "../assets/images/logo_ak_full.png";
import { Portal, perr, portalToken } from "./portalApi";
import "./portal.css";

const MeContext = createContext(null);
export const usePortalMe = () => useContext(MeContext);

function PasswordModal({ open, onClose }) {
  const [form] = Form.useForm();
  const [busy, setBusy] = useState(false);
  const save = async () => {
    const v = await form.validateFields();
    setBusy(true);
    try {
      const r = await Portal.changePassword(v.old_password, v.new_password);
      portalToken.set(r.data.data.token);
      message.success("เปลี่ยนรหัสผ่านแล้ว");
      form.resetFields();
      onClose();
    } catch (e) {
      message.error(perr(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Modal open={open} title="เปลี่ยนรหัสผ่าน" onCancel={onClose} onOk={save} okText="บันทึก" cancelText="ยกเลิก" confirmLoading={busy} destroyOnClose>
      <Form form={form} layout="vertical" requiredMark={false}>
        <Form.Item name="old_password" label="รหัสผ่านปัจจุบัน" rules={[{ required: true, message: "กรอกรหัสผ่านปัจจุบัน" }]}>
          <Input.Password autoComplete="current-password" autoCapitalize="none" />
        </Form.Item>
        <Form.Item name="new_password" label="รหัสผ่านใหม่" rules={[{ required: true, message: "กรอกรหัสผ่านใหม่" }, { min: 6, message: "อย่างน้อย 6 ตัว" }]}>
          <Input.Password autoComplete="new-password" autoCapitalize="none" />
        </Form.Item>
        <Form.Item
          name="confirm"
          label="ยืนยันรหัสผ่านใหม่"
          dependencies={["new_password"]}
          rules={[
            { required: true, message: "กรอกอีกครั้ง" },
            ({ getFieldValue }) => ({ validator: (_, v) => (!v || v === getFieldValue("new_password") ? Promise.resolve() : Promise.reject(new Error("รหัสผ่านไม่ตรงกัน"))) }),
          ]}
        >
          <Input.Password autoComplete="new-password" autoCapitalize="none" />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default function PortalLayout() {
  const navigate = useNavigate();
  const [me, setMe] = useState(null);
  const [pw, setPw] = useState(false);
  const has = !!portalToken.get();

  useEffect(() => {
    document.title = "AK HOME · ติดตามงานสร้างบ้าน";
    if (has) Portal.me().then((r) => setMe(r.data.data)).catch(() => {});
  }, []);

  if (!has) return <Navigate to="/login" replace />;

  const logout = () => {
    portalToken.clear();
    navigate("/login", { replace: true });
  };

  return (
    <MeContext.Provider value={me}>
      <div className="pt-shell">
        <header className="pt-header">
          <div className="pt-header-in">
            <img src={logo} alt="AK HOME" className="pt-logo" onClick={() => navigate("/portal")} />
            <Dropdown
              trigger={["click"]}
              menu={{
                items: [
                  { key: "pw", icon: <KeyOutlined />, label: "เปลี่ยนรหัสผ่าน", onClick: () => setPw(true) },
                  { key: "out", icon: <LogoutOutlined />, label: "ออกจากระบบ", danger: true, onClick: logout },
                ],
              }}
            >
              <Flex align="center" gap={8} className="pt-user">
                <Typography.Text className="pt-user-name" ellipsis>
                  {me?.name || ""}
                </Typography.Text>
                <Avatar size={32} icon={<UserOutlined />} style={{ background: "#9b6420" }} />
              </Flex>
            </Dropdown>
          </div>
        </header>
        <main className="pt-main">{me ? <Outlet /> : <Flex justify="center" style={{ padding: 60 }}><Spin /></Flex>}</main>
        <footer className="pt-footer">บริษัท เอ เค โฮม ศูนย์รับสร้างบ้าน จำกัด</footer>
        <PasswordModal open={pw} onClose={() => setPw(false)} />
      </div>
    </MeContext.Provider>
  );
}
